import { NgModule } from '@angular/core';
import { ClaimListComponent } from './claim-list/claim-list.component';
import { ClaimDetailComponent } from './claim-detail/claim-detail.component';
import { ClaimDatesComponent } from './claim-dates/claim-dates.component';
import { ClaimPartiesComponent } from './claim-parties/claim-parties.component';
import { AssociatedClaimsComponent } from './associated-claims/associated-claims.component';
import { ClaimFeesDisbursementsComponent } from './claim-fees-disbursements/claim-fees-disbursements.component';
import { ClaimReservesPaymentsComponent } from './claim-reserves-payments/claim-reserves-payments.component';
import { ClaimDateSearchComponent } from './claim-list/claim-date-search/claim-date-search.component';
import { ClaimNameSearchComponent } from './claim-list/claim-name-search/claim-name-search.component';
import { ClaimRefSearchComponent } from './claim-list/claim-ref-search/claim-ref-search.component';
import { ClaimInsurerSearchComponent } from './claim-list/claim-insurer-search/claim-insurer-search.component';
import { ClaimStatusSearchComponent } from './claim-list/claim-status-search/claim-status-search.component';
import { ClaimLocationSearchComponent } from './claim-list/claim-location-search/claim-location-search.component';
import { ClaimHandlerSearchComponent } from './claim-list/claim-handler-search/claim-handler-search.component';

import { EventListComponent } from '../communication/event-list/event-list.component';
import { DocumentListComponent } from '../communication/document-list/document-list.component';
import { EventPagerComponent } from '../communication/event-pager/event-pager.component';
import { CrawfordControlsModule } from 'crawford-shell';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { EventDetailComponent } from '../communication/event-detail/event-detail.component';
import { EmailComponent } from '../communication/email/email.component';
import { DocumentDownloadComponent } from '../communication/document-download/document-download.component';
import { ClaimExportComponent } from './claim-export/claim-export.component';
import { ClaimAdjusterInfoComponent } from './claim-adjuster-info/claim-adjuster-info.component';
import { CurrentUserSearchesComponent } from '../saved-search/current-user-searches/current-user-searches.component';
import { AllUserSearchesComponent } from '../saved-search/all-user-searches/all-user-searches.component';
import { SaveSearchDialogComponent } from '../saved-search/save-search-dialog/save-search-dialog.component';
import { SearchListComponent } from '../saved-search/search-list/search-list.component';
import { ClaimAdjusterFeesComponent } from './claim-adjuster-fees/claim-adjuster-fees.component';
import { ClaimPresentPositionComponent } from './claim-present-position/claim-present-position.component';
import { ClaimMediaComponent } from './claim-media/claim-media.component';
import { ClaimSourceSearchComponent } from './claim-list/claim-source-search/claim-source-search.component';
import { ClaimExportDialogComponent } from './claim-export/dialog/claim-export-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    CrawfordControlsModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    ClaimListComponent,
    ClaimDetailComponent,
    ClaimDatesComponent,
    ClaimPartiesComponent,
    AssociatedClaimsComponent,
    ClaimFeesDisbursementsComponent,
    ClaimReservesPaymentsComponent,
    AssociatedClaimsComponent,
    ClaimDateSearchComponent,
    ClaimNameSearchComponent,
    ClaimRefSearchComponent,
    ClaimInsurerSearchComponent,
    ClaimStatusSearchComponent,
    ClaimLocationSearchComponent,
    ClaimHandlerSearchComponent,
    EventListComponent,
    DocumentListComponent,
    EventDetailComponent,
    EmailComponent,
    DocumentDownloadComponent,
    ClaimAdjusterInfoComponent,
    ClaimExportComponent,
    CurrentUserSearchesComponent,
    AllUserSearchesComponent,
    SaveSearchDialogComponent,
    SearchListComponent,
    ClaimAdjusterFeesComponent,
    ClaimPresentPositionComponent,
    ClaimMediaComponent,
    ClaimExportDialogComponent,
    ClaimSourceSearchComponent,
    EventPagerComponent
  ],
  exports: [
    ClaimListComponent,
    ClaimDetailComponent,
    ClaimDatesComponent,
    ClaimPartiesComponent,
    AssociatedClaimsComponent,
    ClaimFeesDisbursementsComponent,
    ClaimReservesPaymentsComponent,
    AssociatedClaimsComponent,
    ClaimDateSearchComponent,
    ClaimNameSearchComponent,
    ClaimRefSearchComponent,
    ClaimInsurerSearchComponent,
    ClaimStatusSearchComponent,
    ClaimLocationSearchComponent,
    ClaimHandlerSearchComponent,
    EventListComponent,
    DocumentListComponent,
    EventDetailComponent,
    CurrentUserSearchesComponent,
    AllUserSearchesComponent,
    SaveSearchDialogComponent,
    SearchListComponent,
    EventPagerComponent
  ]
})
export class ClaimModule { }



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/claim/claim.module.ts